<template>
  <div class="history-publish">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多数据"
      @load="onLoad"
    >
      <div class="game-list" v-for="(item, i) in gameList" :key="i">
        <h1 class="game-date">{{ item.date }}</h1>
        <div class="game-item" v-for="(info, i) in item.hisGameList" :key="i">
          <div class="game-item-content" @click="jumpDetail(info)">
            <img class="game-logo" :src="info.logo_url" alt="" />
            <div class="game-info">
              <div class="game-info-title">
                <h1>{{ info.game_name }}</h1>
                <span>{{ info.discount }}</span>
              </div>
              <div class="game-info-desc">
                <div class="game-info-gift">
                  <span v-if="info.wealf">福利</span>
                  <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                  <span v-if="info.isBTgame">变态特权</span>
                  <span v-if="info.waterMark == 1">专属折扣</span>
                  <span
                    v-if="
                      info.havaGift == 0 &&
                      !info.isBTgame &&
                      !info.wealf &&
                      info.waterMark == 0
                    "
                    >{{ info.title }}</span
                  >
                </div>
                <div class="star" v-if="info.starInfo">
                  <img
                    :key="star"
                    v-for="star in info.starInfo.allStar"
                    src="@/assets/images/star_all.png"
                    alt=""
                  />
                  <img
                    :key="star+999"
                    v-for="star in info.starInfo.halfStar"
                    src="@/assets/images/star_half.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="game-tag">
                <span v-for="tag in info.formatGameType" :key="tag">{{
                  tag
                }}</span>
                <span class="other-tag">{{ info.openServerDate }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="game-item-operate">
            <span @click="doRecharge(info, 'recharge')">充值</span>
            <span @click="doRecharge(info, 'download')">下载</span>
          </div> -->
          <operateBtns :gameInfo="info" @doOperate="doOperate" />
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import mixins from "@/mixin";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  mixins: [mixins],
  components: {
    operateBtns
  },
  data() {
    return {
      gameList: [],
      loading: false,
      finished: false,
      location: "PUBLIC_PARISE",
      totalCount: 0,
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
  },
  methods: {
    async onLoad() {
      await this.gameListQr();

      // 加载状态结束
      this.loading = false;

      // 数据全部加载完成
      if (this.gameList.length >= this.totalCount) {
        this.finished = true;
      } else {
        this.currentPage++;
      }
    },

    /**
     * 根据分类查询游戏列表
     */
    async gameListQr() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/getGameList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              gameType: "historyPublish",
              location: "GAME_LIST",
            }),
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: 30,
          }
        );
        let list = this.gameInit(data)
        this.gameList.push(...list);
        this.totalCount = totalCount;
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    gameInit(list) {
      this.setGameTag(list);
      this.setGameStar(list);
      return list;
    },
    /**
     * 处理游戏标签和开服信息显示
     */
    setGameTag(list) {
      list.forEach((e) => {
        e.hisGameList.forEach((g) => {
          let formatGameType = [];
          if (g.gameType && g.gameType.length) {
            let isBTgame = g.gameType.includes("BT游戏");
            let hasKouBeiBangTag = g.gameType.includes("口碑榜");
            let hasTeJiaTag = g.gameType.includes("特价");
            g.isBTgame = isBTgame;
            if (hasKouBeiBangTag && hasTeJiaTag) {
              formatGameType.push("口碑榜");
              formatGameType.push("特价");
            } else if (!hasKouBeiBangTag && !hasTeJiaTag) {
              formatGameType.push(...g.gameType.slice(0, 2));
            } else if (hasKouBeiBangTag || hasTeJiaTag) {
              if (hasKouBeiBangTag) {
                formatGameType.push("口碑榜");
              }
              if (hasTeJiaTag) {
                formatGameType.push("特价");
              }
              if (g.gameType.length > 0) {
                let filterArr = g.gameType.filter(
                  (e) => e != "口碑榜" && e != "特价"
                );
                formatGameType.push(filterArr[0]);
              }
            }
          }
          g.formatGameType = formatGameType;
        });
      });
      return list;
    },

    /**
     * 处理游戏星标
     */
    setGameStar(list) {
      list.forEach((e) => {
        e.hisGameList.forEach((k) => {
          let level = Number(k.gamehotlevel);
          if (level == 0) {
            //不设置
          } else if (level == 1) {
            k.starInfo = { allStar: 0, halfStar: 1 };
          } else if (level == 2) {
            k.starInfo = { allStar: 1, halfStar: 0 };
          } else if (level == 3) {
            k.starInfo = { allStar: 1, halfStar: 1 };
          } else if (level == 4) {
            k.starInfo = { allStar: 2, halfStar: 0 };
          } else if (level == 5) {
            k.starInfo = { allStar: 2, halfStar: 1 };
          } else {
            k.starInfo = { allStar: 3, halfStar: 0 };
          }
        });
      });
      return list;
    },

    /**
     * 跳转游戏详情
     */
    jumpDetail(info) {
      this.$router.push({ path: "/detail", query: { gameId: info.game_id } });
    },

    doOperate(info, flag) {
      this.$emit("doOperate", info, flag);
    },
  },
};
</script>

<style lang="scss">
.history-publish {
}
</style>


// WEBPACK FOOTER //
// src/views/firstEpisode/components/HistoryPublish.vue